var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main"},[_c('div',{staticClass:"wp-con clearfix"},[_c('div',{staticClass:"official-left"},[_c('UserBox',{attrs:{"xla":{
          show: 'home_user_module_show',
          click: 'home_user_module_click'
        }}}),_vm._v(" "),_c('ServerList',{attrs:{"xla":{
          show: 'home_server_module_show',
          click: 'home_server_module_click',
          itemClick: 'home_server_item_click'
        }}}),_vm._v(" "),_c('GameIntro',{attrs:{"list":_vm.game.game_intro_list || []}})],1),_vm._v(" "),_c('div',{staticClass:"official-right"},[_c('ActBanner',{attrs:{"list":_vm.game.slice_list || []}}),_vm._v(" "),_c('NoticeList',{attrs:{"list":_vm.game.notice_list || []}}),_vm._v(" "),_c('RoleIntro',{attrs:{"list":_vm.game.role_intro_list || []}})],1),_vm._v(" "),_c('GameCut',{attrs:{"list":_vm.game.screen_list || []}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }